import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
import { PIXI } from '@colonist/pixi';
import { LobbyImage } from '@colonist/types';
import { SocketLobbySend } from './socket/SocketLobbySend.ts';
import { logDebugInfo } from './ui_utils/Utils.ts';
import { notificationController } from './EntryShared.ts';
import { showTranslucentOverlay } from './ui_overlays/showTranslucentOverlay.ts';
import { navigateToPage } from './ui_utils/ClientUtils.ts';
export class UIDocument {
    static debugOptions() {
        if (UIUtilsEjsVariables.isProduction) return;
        logDebugInfo('debugOptions', [
            `Is mobile ${PIXI.utils.isMobile.any}`
        ]);
        logDebugInfo('debugOptions', [
            `Is phone ${PIXI.utils.isMobile.phone}`
        ]);
        logDebugInfo('debugOptions', [
            `Webgl supported ${PIXI.utils.isWebGLSupported()}`
        ]);
        logDebugInfo('debugOptions', [
            `Document referrer ${document.referrer}. Location ${document.location.href}`
        ]);
    }
    static showTestServerPopup() {
        if (UIUtilsEjsVariables.isProduction) return;
        notificationController.showNotification(LobbyImage.Admin, {
            key: 'strings:homePage.header.testServerMessage'
        });
    }
    static webGLCheck() {
        if (PIXI.utils.isWebGLSupported()) return;
        if (UIUtilsEjsVariables.isUserOnDiscord) this.showHardwareAccelerationPopup();
        else if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) this.showWebGLPopupOnMobileApp();
        else this.showWebGLPopup();
    }
    static monitorIfUserInteractedWithSite(hasUserAlreadyInteractedWithSiteInPreviousSession) {
        if (hasUserAlreadyInteractedWithSiteInPreviousSession) return;
        if (this.interactedWithSiteEventListener != undefined) return;
        this.interactedWithSiteEventListener = ()=>this.sendUserInteractedWithSite();
        document.addEventListener('mousemove', this.interactedWithSiteEventListener);
        document.addEventListener('mousedown', this.interactedWithSiteEventListener);
    }
    static sendUserInteractedWithSite() {
        if (this.interactedWithSiteEventListener == undefined) return;
        document.removeEventListener('mousemove', this.interactedWithSiteEventListener);
        document.removeEventListener('mousedown', this.interactedWithSiteEventListener);
        SocketLobbySend.interactedWithSite();
    }
    static showWebGLPopup() {
        showTranslucentOverlay({
            title: {
                key: 'strings:homePage.popups.webGLInactive.title'
            },
            body: {
                key: 'strings:homePage.popups.webGLInactive.body'
            },
            confirmLabel: {
                key: 'strings:homePage.popups.webGLInactive.showMeHow'
            },
            onConfirm: ()=>navigateToPage('https://blog.colonist.io/how-to-enable-webgl/')
        });
    }
    static showHardwareAccelerationPopup() {
        showTranslucentOverlay({
            title: {
                key: 'strings:homePage.popups.hardwareAccelerationRequired.title'
            },
            body: 'strings:homePage.popups.hardwareAccelerationRequired.body'
        });
    }
    static showWebGLPopupOnMobileApp() {
        showTranslucentOverlay({
            title: {
                key: 'strings:homePage.popups.webGLInactiveOnMobileApp.title'
            },
            body: {
                key: 'strings:homePage.popups.webGLInactiveOnMobileApp.body'
            }
        });
    }
}
